import script from "./DefDemo.vue?vue&type=script&setup=true&lang=js"
export * from "./DefDemo.vue?vue&type=script&setup=true&lang=js"

import "./DefDemo.vue?vue&type=style&index=0&id=9fe341a6&lang=css"

const __exports__ = script;

export default __exports__